module.exports = __webpack_public_path__ + "static/hapi.82cb7bf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/hapi.svg
// module id = 546
// module chunks = 35783957827783